import axios from "axios";

export const fetchCompany = async () => {
  try {
    const response = await axios.get("http://localhost:8080/webnet-hms/api/company/all");
    const rawData = response.data.data;
    const flatData = rawData.flat();
    return flatData;
  } catch (error) {
    console.error("Error fetching company:", error);
    return [];
  }
};
export const fetchCompany1 = async (id) => {
  try {
    const response = await axios.get(`http://localhost:8080/webnet-hms/api/company/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching comapny:", error);
    return [];
  }
};
export const fetchCompanyByDate = async (fromDate, toDate) => {
  try {
    const response = await axios.get(`http://localhost:8080/webnet-hms/api/company/date-filter?fromDate=${fromDate}&toDate=${toDate}` );
    const rawData = response.data.data;
    const flatData = rawData.flat();
    return flatData;
  } catch (error) {
    console.error("Error fetching companies by date:", error);
    throw error;
  }
};


/* {
  params: {
    fromDate,
    toDate,
  },
} */